import React from 'react';
import { FaArrowRightLong } from 'react-icons/fa6';


const BookAppointment = () => {
  return (
    <div className="book-main">
      <div className="container">
        <div className="book-inner-main">

          <div className="book-child">
            <div className="book-inner-child">
              <span className="book-one">Book An</span>
              <span className="book-two">Appointment</span>
            </div>
          </div>

          <div className="book-child">
            <div className="book-inner-child">
              <div className="book-btn">
                <a
                  href="https://cal.com/galaxyerp-team-brxd8h/30min?month"
                  className="book-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>Get in touch</span>
                  <FaArrowRightLong className="book-icon" />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <video autoPlay muted loop id="myvideo">
        <source src="assets/video/appoinment2.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default BookAppointment;